module.exports = __webpack_public_path__ + "img/handyman.5d3486e7.svg";